import PlayedAtRow from './PlayedAtRow'

export default PlayedAtRow
